import getTranslation from 'bdata-sns-shared/utils/getTranslation';

const getNotableGameLabel = (flags, dictionary, labelType) => {
    const { perfectGame, noHitter } = flags;
    const perfectGameKey = (labelType === 'short') ? 'game_perfectgame' : 'game_perfectgame_long';
    const label = perfectGame
        ? getTranslation(dictionary, perfectGameKey, 'Perfect Game')
        : noHitter
            ? getTranslation(dictionary, 'game_nohitter', 'No-Hitter')
            : '';
    return label;
};

export default getNotableGameLabel;